import React, { useCallback } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import createEventPayload from '../../analytics.codegen';
import { ANALYTICS_CHANNEL } from '../../common/constants';
import { failUfoExperience, ufoExperience } from '../../common/analytics/experiences';
import { useLinkPickerSessionId } from '../../controllers/session-provider';
import { ErrorBoundaryFallback } from './error-boundary-fallback';
import { BaseErrorBoundary } from './error-boundary-base';
function ErrorBoundary(_ref) {
  var children = _ref.children,
    createAnalyticsEvent = _ref.createAnalyticsEvent;
  var linkPickerSessionId = useLinkPickerSessionId();
  var handleError = useCallback(function (error, info) {
    var _window, _window$navigator, _info$componentStack;
    // Fire Analytics event
    createAnalyticsEvent(createEventPayload('ui.linkPicker.unhandledErrorCaught', {
      browserInfo: ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) || 'unknown',
      error: error.toString(),
      componentStack: (_info$componentStack = info === null || info === void 0 ? void 0 : info.componentStack) !== null && _info$componentStack !== void 0 ? _info$componentStack : ''
    })).fire(ANALYTICS_CHANNEL);

    // Fire UFO failed experience
    failUfoExperience(ufoExperience.mounted, linkPickerSessionId);
  }, [createAnalyticsEvent, linkPickerSessionId]);
  return /*#__PURE__*/React.createElement(BaseErrorBoundary, {
    onError: handleError,
    ErrorComponent: ErrorBoundaryFallback
  }, children);
}
export default withAnalyticsEvents()(ErrorBoundary);